import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'ecp-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.css']
})
export class TopNavComponent implements OnInit {

  // å¤çè­¦å
  disposedId(id) {
    alert('alarmç»ä»¶åä¼ ID------' + id);
  }

  test(txt) {
    console.log(txt);
  }


  constructor() {
  }

  ngOnInit() {
  }

}
